<template>
    <v-dialog scrollable v-model="packingRuleTester" width="80%">
        <template v-slot:activator="{ on, attrs }">
            <v-btn small v-bind="attrs" v-on="on">
                Test Packing Rules
            </v-btn>
        </template>
        <v-card>

            <v-card-title>
                <span>Test Packing Rules</span>
            </v-card-title>

            <v-card-text>
                <v-container fluid>

                    <v-tabs
                        v-model="tab">
                        <v-tab>Items</v-tab>
                        <v-tab>Result</v-tab>
                        <v-tab>Logs</v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item>
                            <div class="pt-3">
                                <p class="modal-label">Update or paste the Standard Items json below.</p>
                                <div class="textarea-wrapper">
                                    <!-- Line Numbers -->
                                    <div class="line-numbers" ref="lineNumbers">
                                        <div v-for="n in lineCount" :key="n">{{ n }}</div>
                                    </div>

                                    <!-- Textarea -->
                                    <v-textarea
                                        v-model="jsonData"
                                        :disabled="isLoading"
                                        @input="onJsonDataChange"
                                        hide-details
                                        solo
                                        auto-grow
                                        class="custom-textarea"
                                        ref="textarea"
                                        rows="10"
                                        >
                                    </v-textarea>
                                </div>
                            </div>
                        </v-tab-item>
                        <v-tab-item>
                            <div class="">
                                <v-textarea
                                    v-if="result"
                                    v-model="result"
                                    hide-details
                                    auto-grow
                                    rows="10"
                                    >
                                </v-textarea>
                            </div>
                        </v-tab-item>
                        <v-tab-item>
                            <div>
                                <ItemPackingLogs :testLogs="logs" />
                            </div>
                        </v-tab-item>
                    </v-tabs-items>



                </v-container>
            </v-card-text>

            <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
                <v-btn small @click="packingRuleTester = false">Close</v-btn>
                <v-btn small color="primary" @click="testPackingRules" :disabled="isLoading">
                    <v-progress-circular
                        v-if="isLoading"
                        indeterminate
                        size="12"
                        width="2"
                        color="green darken-3"
                        class="mr-2">
                    </v-progress-circular>
                    {{ isLoading ?'Testing':'Test' }} Packing Rules
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.v-dialog__container {
    display: unset;
}

.textarea-wrapper {
    display: flex;
    font-size: 14px;
    line-height: 1.5;
    border: 1px solid #ccc;
    border-radius: 4px;
    overflow: hidden;
    background-color: #f4f4f4;
    height: auto;
}

.line-numbers {
    padding: 8px 12px;
    background-color: #f4f4f4;
    border-right: 1px solid #ccc;
    text-align: right;
    user-select: none;
    white-space: nowrap;
}

.custom-textarea ::v-deep(textarea) {
    font-size: 14px;
    line-height: 1.5;
    padding: 0;
    white-space: pre; /* No text wrapping */
    overflow-x: auto; /* Horizontal scroll */
    resize: none;
    min-height: auto;
    padding-bottom: 20px;
}

</style>

<script>
import { EventBus } from '@/js/event-bus.js'
import ItemPackingLogs from '@/js/components/logs/ItemPackingLogs.vue'
export default {
    components: {
        ItemPackingLogs
    },
    props: {
        value: Boolean, // for v-model binding
        integrationId: Number,
    },

    data() {
        return {
            packingRuleTester: false,
            jsonData: '',
            isLoading: false,
            parsedData: [],
            errorMessage: '',
            lineCount: 1,
            tab: 0,
            result: '',
            logs: []
        }
    },

    computed: {

        lineNumbers() {
            return Array.from({ length: this.lineCount }, (_, i) => i + 1).join('\n')
        }
    },

    mounted() {
        this.updateLineCount();
    },

    methods: {

        syncTextAreaAndLineHeights() {
            const textarea = this.$refs.textarea ? this.$refs.textarea.$el.querySelector("textarea") : null;
            const lineNumbers = this.$refs.lineNumbers;

            if (textarea && lineNumbers) {
                const newHeight = textarea.scrollHeight > 0 ? textarea.scrollHeight : 40;
                lineNumbers.style.height = `${newHeight}px`;
            }
        },

        updateLineCount() {
            this.lineCount = this.jsonData.split('\n').length
            this.$nextTick(this.syncTextAreaAndLineHeights); // Ensure DOM updates before syncing heights
        },

        onJsonDataChange() {
            this.isLoading = false;
            this.parsedData = [];
            this.errorMessage = '';
            this.updateLineCount();
        },

        testPackingRules() {

            this.result = '';
            this.parsedData = [];
            this.isLoading = true;

            this.$http
                .post(`api/test-packing-rules/${this.integrationId}`, this.jsonData)
                .then(({ data }) => {
                    this.result = JSON.stringify(data.data.result, null, 2);
                    this.logs = data.data.logs;
                    this.tab = 1;
                })
                .finally(() => {
                    this.isLoading = false;
                })
                .catch((error) => {
                    EventBus.$emit('show-error', error)
                });

        },
    }
}
</script>